<template>
	<div class="filter planning">
		<h1 class="thermo">Filter</h1>
		<div class="filter-item">
			<span @click="emitFilterChange('default')">Standaard</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'default'"
				@change="emitFilterChange('default')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('opnieuw_bellen')">Moeilijk te bereiken</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'opnieuw_bellen'"
				@change="emitFilterChange('opnieuw_bellen')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('opnieuw_inplannen')">Opnieuw inplannen</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'opnieuw_inplannen'"
				@change="emitFilterChange('opnieuw_inplannen')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('@4x_@5x')">@4x en @5x</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === '@4x_@5x'"
				@change="emitFilterChange('@4x_@5x')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('kmk')">KMK + ThermoTrees</span>
			<ToggleField
				type="radio" name="filter" :checked="currentFilter === 'kmk'" @change="emitFilterChange('kmk')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('geen_locatie')">Geen locatie</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'geen_locatie'"
				@change="emitFilterChange('geen_locatie')"
			/>
		</div>
	</div>
</template>

<script>
import ToggleField from "@/components/ToggleField.vue";
import moment from "moment";

export default {
	components: {
		ToggleField,
	},

	props: {
		filter: String
	},
	watch: {
		filter() {
			if(this.filter === this.currentFilter){
				return;
			}
			this.currentFilter = this.filter;
			this.emitFilterChange(this.filter);
		}
	},

	data() {
		return {
			currentFilter: 'default',
			afterDate: moment().subtract(1, "months").format("YYYY-MM-DD")
		};
	},

	mounted() {
		this.emitFilterChange(this.currentFilter);
	},
	methods: {
		emitFilterChange(filter) {
			this.currentFilter = filter;
			this.$emit('filterChange', {
				filter: this.currentFilter,
				afterDate: this.afterDate
			});
		}
	}
};
</script>

<style scoped lang="scss">
.filter-item {
	display: flex; justify-content: space-between; margin-bottom: 0.5em;
}
</style>
